import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function FullLoader({ label = "Loading" }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center" data-testid="full-loader">
      <div className="flex flex-col items-center gap-3 text-ff-medium">
        <Loader2 className="h-8 w-8 animate-spin text-ff-red" />
        <span className="text-sm font-medium">{label}…</span>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, requireAdmin = false, requireSuperAdmin = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) return <FullLoader label="Checking your session" />;
  if (user === false)
    return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  const isAdmin = user.role === "admin" || user.role === "superadmin";
  if (requireSuperAdmin && user.role !== "superadmin")
    return <Navigate to="/admin/reviews" replace />;
  if (requireAdmin && !isAdmin)
    return <Navigate to="/" replace />;
  return children;
}
